import { render, staticRenderFns } from "./ProdutoImagem.vue?vue&type=template&id=c553df48"
import script from "./ProdutoImagem.vue?vue&type=script&lang=js"
export * from "./ProdutoImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports